/* @ngInject */
const local = (
  valueHandler,
  storageHandler
) => {
  const self = {}

  self.saveCurrentId = (_id) => {
    if (valueHandler.isId(_id)) {
      storageHandler.save('currentDispatchId', _id)
    } else if (valueHandler.isId(_id.id)) {
      storageHandler.save('currentDispatchId', _id.id)
    }
  }

  self.getCurrentId = () => {
    return storageHandler.get('currentDispatchId')
  }

  return self
}

export default local



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/dispatch/services/local.service.js